import { Component } from '@angular/core';

@Component({
  selector: 'app-central-administration-responsibility',
  templateUrl: './central-administration-responsibility.component.html',
  styleUrl: './central-administration-responsibility.component.scss'
})
export class CentralAdministrationResponsibilityComponent {

}
